import axios from 'axios';
import { getBaseApiUrl } from '../util/config';

export default async values =>
  await axios.post(`${getBaseApiUrl()}/VMF/SubmitCommercialLendingForm`, {
    form: values,
  });
